import { Play } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import type { Scenario } from 'hooks/scenarios/scenarioHooks';
import { describeScenario } from './scenarioFormModel';

const SEARCH_LABEL = 'Search scenarios…';
const COLUMNS = 3;

type Props = {
  scenarios: Scenario[];
  search: string;
  onSearchChange: (next: string) => void;
  onEdit: (scenario: Scenario) => void;
  onLaunch: (scenario: Scenario) => void;
  emptyMessage: string;
};

/** Presentational list of saved responses. */
export function ScenariosTable({
  scenarios,
  search,
  onSearchChange,
  onEdit,
  onLaunch,
  emptyMessage,
}: Props) {
  return (
    <div className="tw:space-y-2">
      <Input
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder={SEARCH_LABEL}
        aria-label={SEARCH_LABEL}
        className="tw:h-8"
      />
      <div className="tw:overflow-x-auto tw:rounded-md tw:border tw:border-border">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Scenario</TableHead>
              <TableHead>What it does</TableHead>
              <TableHead className="tw:w-[110px]" />
            </TableRow>
          </TableHeader>
          <TableBody>
            {scenarios.length === 0 ? (
              <TableRow>
                <TableCell
                  colSpan={COLUMNS}
                  className="tw:text-center tw:text-muted-foreground"
                >
                  {emptyMessage}
                </TableCell>
              </TableRow>
            ) : (
              scenarios.map((scenario) => (
                <TableRow
                  key={scenario.id}
                  className="tw:cursor-pointer"
                  onClick={() => onEdit(scenario)}
                >
                  <TableCell>
                    <span className="tw:font-medium">{scenario.name}</span>
                    {scenario.description ? (
                      <div className="tw:text-xs tw:text-muted-foreground">
                        {scenario.description}
                      </div>
                    ) : null}
                  </TableCell>
                  <TableCell className="tw:text-xs tw:text-muted-foreground">
                    {describeScenario(scenario)}
                  </TableCell>
                  <TableCell>
                    <Button
                      type="button"
                      size="xs"
                      className="tw:gap-1"
                      onClick={(event) => {
                        event.stopPropagation();
                        onLaunch(scenario);
                      }}
                    >
                      <Play className="tw:size-3" />
                      Launch
                    </Button>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}

export default ScenariosTable;
